<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Liste des sites</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color="AlertColor(type)"
                 :dismissible="true"
                 :value="true"
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <modal :adaptive="true"
               :clickToClose="false"
               :draggable="false"
               :resizable="false"
               height="auto"
               name="modal-fade">
          <v-card>
            <v-toolbar
                color="#01579B"
                dark
                flat>
              <v-text-field :id="dynamicID()" class="text--darken-3 mt-3"
                            dense
                            hide-details
                            readonly
                            rounded
                            v-model="modifier">
              </v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                  @click="hide()"
                  dark
                  fab
                  small>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-alert :color="AlertColorS(typeS)"
                       :dismissible="true"
                       :value="true"
                       border="top"
                       class="pre-formatted multi-line"
                       colored-border
                       elevation="2"
                       icon="check_circle"
                       v-if="typeS">
                {{ text }}
              </v-alert>
              <v-container>
                <v-card-text>
                  <v-container>
                    <v-stepper v-model="e6" vertical>
                      <v-stepper-step :complete="e6 > 1" :editable="true" step="1">
                        Informations du site
                      </v-stepper-step>
                      <v-stepper-content step="1">
                        <v-row>
                          <v-col cols="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input"
                                          label="Nom du site"
                                          v-model="editedItem.nom"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-select :items="companies"
                                      class="centered-input text-center"
                                      item-text="name"
                                      item-value="id"
                                      label="Entreprise"
                                      v-model="editedItem.companyId">
                              <template v-slot:selection="{ item }">
                                <div style="width: 100%; text-align: center !important;">
                                  {{ item.name }}
                                </div>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input"
                                          label="Adresse"
                                          v-model="editedItem.address"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field :id="dynamicID()"
                                          class="centered-input"
                                          label="Téléphone"
                                          type="text"
                                          v-model="editedItem.phone">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-btn @click="e6 = 2" class="mb-2"
                               color="primary"><span
                            class="material-icons"> done_all </span></v-btn>
                      </v-stepper-content>
                    </v-stepper>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :disabled="!FormIsValidModif && !loading" @click="updateSite()"
                         class="white--text"
                         color="#01579B" depressed>Modifier site
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </modal>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexport" block class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export sites</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="600px" persistent v-model="dialog">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn :disabled="disableMainBtn" @click="init()" block
                         class="custom-btn white--text"
                         color="#009688" height="45px"
                         large v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span> Création site </span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-container>
                      <v-stepper v-model="e6" vertical>
                        <v-stepper-step :complete="e6 > 1" :editable="true" step="1">
                          Informations du site
                        </v-stepper-step>
                        <v-stepper-content step="1">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input"
                                            label="Nom du site"
                                            v-model="editedItem.nom"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-select :items="companies"
                                        class="centered-input"
                                        item-text="name"
                                        item-value="id"
                                        label="Entreprise"
                                        v-model="editedItem.companyId">
                                <template v-slot:selection="{ item }">
                                <span>
                                  {{ item.name }}
                                </span>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input"
                                            label="Adresse"
                                            v-model="editedItem.address"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input"
                                            label="Téléphone"
                                            type="text"
                                            v-model="editedItem.phone">
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-btn @click="e6 = 2" class="mb-2"
                                 color="primary"><span
                              class="material-icons"> done_all </span></v-btn>
                        </v-stepper-content>
                      </v-stepper>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="!FormIsValid && !loading" @click="createSite()"
                           class="white--text"
                           color="#01579B" depressed>Créer site
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "site",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      modifier: "",
      typeS: null,
      elapse: null,
      type: null,
      lastHighlitedRow: null,
      loading: false,
      loading2: false,
      e6: 1,
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      toObject: [],
      companies: [],
      editedItem: {
        id: "",
        nom: "",
        companyId: "",
        nomCompany: "",
        address: "",
        phone: "",
        disabled: false,
        creationDate: ""
      },
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: {
          items: {
            modifier: {
              name: "Modifier",
              callback(key, selection, clickEvent) { // Callback for specific option
                setTimeout(() => {
                  let start = selection[0].start
                  window.displayTitleModif(start.row)
                  window.updateData4Modif(start.row)
                  window.show()
                }, 0);
              }
            },
            sp1: '---------',
            remove_row: {
              name: "Supprimer"
            }
          }
        },
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        afterOnCellMouseDown: this.afterOnCellMouseDownMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0, 5],
          indicators: false
        },
        colHeaders: [
          "Id", "Nom site", "Nom entreprise", "Adresse", "Téléphone", "Date création", "Statut"
        ],
        columns: [
          {title: "Id", width: "10px", readOnly: true},
          {title: "Nom site", width: "250px"},
          {title: "Nom entreprise", width: "250px", readOnly: true},
          {title: "Adresse", width: "250px"},
          {title: "Téléphone", width: "150px"},
          {
            title: "Date de création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {
            title: "Statut",
            width: "120px",
            type: "dropdown",
            source: ["Actif", "Inactif"],
            readOnly: false
          }
        ]
      }
    }
  },
  created() {
    this.getData();
    this.getCompanies();
    this.initEditedItem();
  },
  mounted() {
    window.show = this.show;
    window.displayTitleModif = this.displayTitleModif;
    window.updateData4Modif = this.updateData4Modif;
  },
  computed: {
    FormIsValid() {
      return (
          this.editedItem.nom !== "" &&
          this.editedItem.companyId !== "" &&
          this.editedItem.address !== "" &&
          this.editedItem.phone !== ""
      );
    },
    FormIsValidModif() {
      return (
          this.editedItem.nom !== "" &&
          this.editedItem.companyId !== "" &&
          this.editedItem.address !== "" &&
          this.editedItem.phone !== ""
      );
    }
  },
  methods: {
    displayTitleModif(row) {
      let rowT = this.$refs.hotTable.hotInstance.getData()[row]
      this.modifier = "Modifications site " + rowT[1];
    },
    updateData4Modif(row) {
      let rowT = this.$refs.hotTable.hotInstance.getData()[row]
      this.editedItem.id = rowT[0];
      this.editedItem.nom = rowT[1];
      this.editedItem.nomCompany = rowT[2];
      // Retrouver l'ID de l'entreprise à partir du nom
      const company = this.companies.find(c => c.name.toUpperCase() === rowT[2]);
      this.editedItem.companyId = company ? company.id : "";
      this.editedItem.address = rowT[3];
      this.editedItem.phone = rowT[4];
      this.editedItem.creationDate = rowT[5];
      this.editedItem.disabled = rowT[6] === "Inactif";
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    show() {
      this.$modal.show('modal-fade');
    },
    hide() {
      this.$modal.hide('modal-fade');
    },
    init() {
      this.tab = "tab-1";
      this.file = "";
      this.initEditedItem();
      this.refresh();
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    getData() {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/wallet/get_wallet_sites/` + sessionStorage.getItem("accountId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["nom"].toUpperCase(),
                item["nomCompany"].toUpperCase(),
                item["address"],
                item["phone"],
                this.datefull(item["creationDate"]),
                !item["disabled"] ? "Actif" : "Inactif"
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    getCompanies() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/wallet/get_wallet_companies/` + sessionStorage.getItem("accountId")
          )
          .then(response => {
            if (response.data.status === 200) {
              const companies = response.data.datas.map(company => ({
                id: company.id,
                name: company.name
              }));
              this.companies = companies;
            }
          })
          .catch(error => {
            console.error("Erreur lors de la récupération des entreprises:", error);
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    close() {
      this.dialog = false;
      this.initEditedItem();
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    AlertColorS(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlertS(type) {
      this.typeS = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        if (this.typeS === "info") {
          this.hide()
        }
        this.typeS = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 4) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    onexport() { // On Click Excel download button
      this.loading = true
      // export json to Worksheet of Excel
      // only array possible
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Sites") // sheetAName is name of Worksheet

      // export Excel file
      XLSX.writeFile(wb, "Sites.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },
    initEditedItem() {
      this.editedItem = {
        id: "",
        nom: "",
        companyId: "",
        nomCompany: "",
        address: "",
        phone: "",
        disabled: false,
        creationDate: ""
      };
    },
    createSite() {
      this.loading = true;

      // Rechercher le nom de l'entreprise pour l'affichage
      const company = this.companies.find(c => c.id === this.editedItem.companyId);
      const companyName = company ? company.name : "";

      const baseUrl = this.$store.getters.user.baseUrl;
      const nom = encodeURIComponent(this.editedItem.nom);
      const address = encodeURIComponent(this.editedItem.address);
      const phone = encodeURIComponent(this.editedItem.phone);
      const wallet_company_id = this.editedItem.companyId;
      const sender_id = sessionStorage.getItem("accountId");

      // Construction de l'URL avec les paramètres
      const url = `${baseUrl}/wallet/add_wallet_site/${nom}/${address}/${phone}/${wallet_company_id}/${sender_id}`;

      apiClient
          .post(url)
          .then(res => {
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.dialog = false;
              this.getData();
              this.initEditedItem();
              this.showAlert('info');
            } else {
              this.alert = true;
              this.color = "#F44336";
              this.alert = true;
              this.text = res.data.message;
              this.dialog = false;
              this.showAlert('warning');
            }
          })
          .catch(err => {
            this.alert = true;
            this.text = err;
            this.dialog = false;
            this.loading = false;
            this.color = "#F44336";
            this.showAlert('warning');
          });
    },
    updateSite() {
      this.loading = true;

      const baseUrl = this.$store.getters.user.baseUrl;
      const siteId = this.editedItem.id;
      const nom = encodeURIComponent(this.editedItem.nom);
      const address = encodeURIComponent(this.editedItem.address);
      const phone = encodeURIComponent(this.editedItem.phone);
      const wallet_company_id = this.editedItem.companyId;
      const sender_id = sessionStorage.getItem("accountId");

      // Construction de l'URL avec les paramètres
      const url = `${baseUrl}/wallet/update_wallet_site/${siteId}/${nom}/${address}/${phone}/${wallet_company_id}/${sender_id}`;

      apiClient
          .post(url)
          .then(res => {
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.hide();
              this.getData();
              this.initEditedItem();
              this.showAlertS('info');
            } else {
              this.alert = true;
              this.color = "#F44336";
              this.alert = true;
              this.text = res.data.message;
              this.showAlertS('warning');
            }
          })
          .catch(err => {
            this.alert = true;
            this.text = err;
            this.loading = false;
            this.color = "#F44336";
            this.showAlertS('warning');
          });
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification du site.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.loading = true;
              let obj = {};

              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]];

              if (changes[0][1] === 6) {  // Colonne "Statut" est à l'index 6
                // Toggle statut Actif/Inactif
                let urlTmp = "";
                if (changes[0][3] === "Actif") {
                  urlTmp = `${this.$store.getters.user.baseUrl}/wallet/enable_wallet_site/${obj[0]}/${sessionStorage.getItem("accountId")}`;
                } else if (changes[0][3] === "Inactif") {
                  urlTmp = `${this.$store.getters.user.baseUrl}/wallet/disable_wallet_site/${obj[0]}/${sessionStorage.getItem("accountId")}`;
                }

                apiClient
                    .post(urlTmp)
                    .then(res => {
                      dialog.close();
                      this.loading = false;
                      if (res.data.status === 200) {
                        this.color = "#009688";
                        this.text = res.data.message;
                        this.showAlert('info');
                      } else {
                        this.alert = true;
                        this.color = "#F44336";
                        this.alert = true;
                        this.text = res.data.message;

                        let myData = this.$refs.hotTable.hotInstance.getData();
                        myData[changes[0][0]][changes[0][1]] = changes[0][2];
                        this.$refs.hotTable.hotInstance.loadData(myData);

                        this.showAlert('warning');
                      }
                    })
                    .catch((err) => {
                      dialog.close();
                      this.alert = true;
                      this.color = "#F44336";
                      this.text = err.data ? err.data.message : err;
                      this.loading = false;

                      let myData = this.$refs.hotTable.hotInstance.getData();
                      myData[changes[0][0]][changes[0][1]] = changes[0][2];
                      this.$refs.hotTable.hotInstance.loadData(myData);

                      this.showAlert('warning');
                    });
              } else {
                // Récupérer l'ID de l'entreprise à partir du nom de l'entreprise
                const company = this.companies.find(c => c.name.toUpperCase() === obj[2]);
                const wallet_company_id = company ? company.id : "";

                if (!wallet_company_id) {
                  dialog.close();
                  this.alert = true;
                  this.color = "#F44336";
                  this.text = "Entreprise non trouvée";
                  this.loading = false;
                  this.showAlert('warning');
                  return;
                }

                // Update other fields
                const baseUrl = this.$store.getters.user.baseUrl;
                const siteId = obj[0];
                const nom = encodeURIComponent(obj[1]);
                const address = encodeURIComponent(obj[3]);
                const phone = encodeURIComponent(obj[4]);
                const sender_id = sessionStorage.getItem("accountId");

                // Construction de l'URL avec les paramètres
                const url = `${baseUrl}/wallet/update_wallet_site/${siteId}/${nom}/${address}/${phone}/${wallet_company_id}/${sender_id}`;

                apiClient
                    .post(url)
                    .then(res => {
                      dialog.close();
                      this.loading = false;
                      if (res.data.status === 200) {
                        this.color = "#009688";
                        this.text = res.data.message;
                        this.showAlert('info');
                        this.getData();
                      } else {
                        this.alert = true;
                        this.color = "#F44336";
                        this.alert = true;
                        this.text = res.data.message;

                        let myData = this.$refs.hotTable.hotInstance.getData();
                        myData[changes[0][0]][changes[0][1]] = changes[0][2];
                        this.$refs.hotTable.hotInstance.loadData(myData);

                        this.showAlert('warning');
                      }
                    })
                    .catch((err) => {
                      this.loading = false;
                      dialog.close();

                      let myData = this.$refs.hotTable.hotInstance.getData();
                      myData[changes[0][0]][changes[0][1]] = changes[0][2];
                      this.$refs.hotTable.hotInstance.loadData(myData);

                      this.alert = true;
                      this.color = "#F44336";
                      this.text = err.data ? err.data.message : err;
                      this.loading = false;
                      this.showAlert('warning');
                    });
              }
            })
            .catch(() => {
              this.loading = false;
              let myData = this.$refs.hotTable.hotInstance.getData();
              myData[changes[0][0]][changes[0][1]] = changes[0][2];
              this.$refs.hotTable.hotInstance.loadData(myData);
            });
      }
    },
    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index];
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression du site.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true;

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/wallet/delete_wallet_site_by_id/${rowId[0]}/${sessionStorage.getItem("accountId")}`
                )
                .then(res => {
                  dialog.close();
                  this.loading = false;
                  if (res.data.status === 200) {
                    this.color = "#009688";
                    this.text = res.data.message;
                    this.showAlert('info');
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);

                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);

                    this.color = "#F44336";
                    this.alert = true;
                    this.text = res.data.message;
                    this.showAlert('warning');
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false;
                  this.alert = true;
                  this.color = "#F44336";
                  this.text = error;
                  this.showAlert('warning');
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);

            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);
          });
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    }
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.centered-input >>> input {
  text-align: center !important;
}

/* Sélecteurs très spécifiques pour le problème de v-select */
.v-select__selections {
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
}

.v-select__selection {
  margin: 0 !important;
  text-align: center !important;
}

/* Pour s'assurer que la case principale reste alignée au centre */
.v-input--selection-controls__input {
  margin: 0 auto !important;
}

/* Forcer l'alignement central du texte dans les sélections */
.v-select .v-select__selection--comma {
  margin: 0 auto !important;
  text-align: center !important;
  width: 100% !important;
  overflow: visible !important;
}

/* Forcer le centrage dans tous les cas */
.v-select .v-input__slot div {
  text-align: center !important;
}
</style>